//@ts-check

import { getEndPoint } from "./endpoint"

/** @type {{accessToken}} */
let currentUser



let cache={}
window['cache']=cache
/**
 * This function is used across the app to send JSON data to the server and handle the response.
 * @param method {"GET"|"POST"|"DELETE"|"PUT"}
 * @param path {string} - e.g. /url
 * @param [data] {Object} - Must be a JSON object or undefined
 * @param [useLocalCache] {boolean} - If use cache
 * @returns {Promise<Object>} - A JSON Response
 */
export async function requestJSON(method, path, data,useLocalCache) {
  var cacheKey=JSON.stringify({method,path,data})
  if(useLocalCache) {
    if(cache[cacheKey]) {
      return cache[cacheKey]
    }
  }

  function formatData(data){
    let formattedData = {};
    if(window['config'].ENCODE_REQUESTS === 'true'){
      formattedData['data'] = Buffer.from(JSON.stringify(data)).toString('base64')
    }else{
      return JSON.stringify(data)
    }
    return JSON.stringify(formattedData);
  }
   
  const endpoint = require("./endpoint").getEndPoint()
  try {
    // Checkmarx fix
    var resPromise = window['f'](endpoint + path, {
      method,
      headers: {
        "content-type": "application/json",
        "content-transfer-encoding": window['config'].ENCODE_REQUESTS === 'true' ? "base64":"",
        // Authorization: `Bearer ${currentUser?.accessToken}`,
      },
      body: data ? formatData(data) : undefined,
      credentials: "include"
    })
    var jsonPromise=resPromise.then(x=>x.json()).catch(()=>null)
    
    cache[cacheKey]=jsonPromise // always save in cache. So if next request will useCache you will have the response

    var res=await resPromise
 
    // check for 400/500 errors (e.g. 401, 404, 500)
    if (res.status >= 400 && res.status < 600) {
      switch (res.status) {
        case 401: {
          // take user to login page
          if(location.href.match(/library($|\/)/)) return
          if(location.href.match(/auth0_callback/)) return
          // disable redirect on incorrect page
          //@ts-ignore
          // window.location = window['config'].AUTH_UI
          return
        }
        default: {
          // display error message to user (e.g. in snack bar)
          console.error(await jsonPromise)
          return
        }
      }
    }
    return jsonPromise
  } catch (error) {
    console.log(error)
    return res
  }
}

export async function invalidateCache(method,path,data){
  var cacheKey=JSON.stringify({method,path,data})
  delete cache[cacheKey]
}
